import axios from "axios";

const getPersonEffectiveContracts = async function (orderId = null) {
  try {
    const res = await axios.get(`/eff_contract/person_eff_contracts.json`, {
      params: {
        order_id: orderId
      }
    });
    return [res.data, null]
  } catch (err) {
    return [null, err.response.data]
  }
}

const getPersonEffectiveContract = async function (id) {
  try {
    const res = await axios.get(`/eff_contract/person_eff_contracts/${id}.json`);
    return [res.data, null]
  } catch (err) {
    return [null, err.response.data]
  }
}

export {
  getPersonEffectiveContract,
  getPersonEffectiveContracts,
}